/** Query keys for the campaign notices table, optionally scoped to an entity. */
export const noticeKeys = {
  all: ["campaign-notices"],
  lists: () => [...noticeKeys.all, "list"],
  list: ({ campaignId = null, entityId = null } = {}) => [
    ...noticeKeys.lists(),
    { campaignId, entityId },
  ],
};
